/*
  Mécanique partagée des popups de sélection de taille (catalog-presenter.liquid,
  card-product-gift.liquid / quanailles-gift-grid.liquid). Ne gère que le comportement
  du dialogue (ARIA, piège de focus, retour de focus) — chaque appelant garde son propre
  HTML/CSS et sa propre logique de rendu des tailles.
  Voir docs/backlog.md (#18) et docs/shopify.md (zones sensibles — popups de taille).
*/
window.QnSizePopup = (function () {
  'use strict';

  var FOCUSABLE_SELECTOR =
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var activeTrap = null;

  function trapFocus(container, triggerEl) {
    var focusables = Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR));
    if (!focusables.length) return null;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    first.focus();

    return {
      release: function () {
        container.removeEventListener('keydown', onKeydown);
        if (triggerEl && typeof triggerEl.focus === 'function') triggerEl.focus();
      }
    };
  }

  function open(popupEl, triggerEl) {
    if (!popupEl) return;
    if (!popupEl.getAttribute('role')) popupEl.setAttribute('role', 'dialog');
    popupEl.setAttribute('aria-modal', 'true');
    if (!popupEl.getAttribute('aria-label')) popupEl.setAttribute('aria-label', 'Choisir une taille');
    popupEl.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    if (activeTrap) activeTrap.release();
    activeTrap = trapFocus(popupEl, triggerEl);
  }

  function close(popupEl) {
    if (!popupEl) return;
    popupEl.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (activeTrap) {
      activeTrap.release();
      activeTrap = null;
    }
  }

  return { open: open, close: close };
})();
